// LoginFormと統一したカラー定義
const COLORS = {
  primary: '#09529f',
  primaryDark: '#002348',
  success: '#28a745',
  danger: '#dc3545',
  dangerBg: '#f8d7da',
  dangerBorder: '#f5c6cb',
  white: '#fff',
  lightGray: '#f8f9fa',
  borderGray: '#dee2e6',
  textGray: '#666',
  appBackground: '#F0F8FF'
};

// メインスタイルオブジェクト
export const newPasswordFormStyles = {
  // ページ全体のコンテナ
  pageContainer: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.appBackground,
    padding: '20px'
  },

  // メインコンテナ
  container: {
    maxWidth: '400px',
    width: '100%',
    backgroundColor: COLORS.white,
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    border: `2px solid ${COLORS.primary}`
  },

  // タイトル
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: COLORS.primary,
    textAlign: 'center',
    marginBottom: '30px',
    borderBottom: `3px solid ${COLORS.primary}`,
    paddingBottom: '15px'
  },

  // 説明テキスト
  description: {
    fontSize: '14px',
    color: COLORS.textGray,
    textAlign: 'center',
    marginBottom: '30px',
    lineHeight: '1.5'
  },

  // フォーム
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },

  // フィールドグループ
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  // ラベル
  label: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '5px'
  },

  // 必須マーク
  required: {
    color: COLORS.danger,
    marginLeft: '3px'
  },

  // パスワード入力コンテナ
  passwordContainer: {
    position: 'relative'
  },

  // 入力フィールド
  input: {
    width: '100%',
    padding: '12px 16px',
    paddingRight: '45px', // アイコン用スペース
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: COLORS.borderGray,
    borderRadius: '6px',
    fontSize: '16px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
    backgroundColor: COLORS.white,
    outline: 'none'
  },

  // 入力フィールド（フォーカス時）
  inputFocus: {
    borderColor: COLORS.primary,
    boxShadow: `0 0 0 2px rgba(9, 82, 159, 0.1)`
  },

  // 入力フィールド（エラー時）
  inputError: {
    borderColor: COLORS.danger,
    boxShadow: `0 0 0 2px rgba(220, 53, 69, 0.1)`
  },

  // パスワード表示/非表示ボタン
  passwordToggle: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: COLORS.textGray,
    fontSize: '16px',
    padding: '4px',
    transition: 'color 0.3s ease'
  },

  // パスワードトグル（ホバー時）
  passwordToggleHover: {
    color: COLORS.primary
  },

  // エラーメッセージ
  errorMessage: {
    color: COLORS.danger,
    fontSize: '14px',
    marginTop: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  },

  // パスワード強度表示
  strengthIndicator: {
    marginTop: '12px',
    padding: '16px',
    backgroundColor: COLORS.lightGray,
    borderRadius: '6px',
    border: `1px solid ${COLORS.borderGray}`
  },

  // パスワード強度表示（有効時）
  strengthIndicatorValid: {
    backgroundColor: '#d4edda',
    borderColor: '#c3e6cb'
  },

  // 強度表示タイトル
  strengthTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#495057',
    marginBottom: '8px'
  },

  // 強度要件リスト
  strengthRequirements: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },

  // 個別要件
  requirement: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },

  // 要件満足
  requirementMet: {
    color: COLORS.success
  },

  // 要件未満足
  requirementUnmet: {
    color: COLORS.danger
  },

  // 総合評価
  strengthSummary: {
    marginTop: '8px',
    fontSize: '13px',
    fontWeight: 'bold'
  },

  // 総合評価（成功）
  strengthSummarySuccess: {
    color: COLORS.success
  },

  // 総合評価（失敗）
  strengthSummaryDanger: {
    color: COLORS.danger
  },

  // メインボタン
  submitButton: {
    width: '100%',
    padding: '14px',
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },

  // メインボタン（ホバー時）
  submitButtonHover: {
    backgroundColor: COLORS.primaryDark,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(9, 82, 159, 0.2)'
  },

  // メインボタン（無効時）
  submitButtonDisabled: {
    backgroundColor: COLORS.textGray,
    cursor: 'not-allowed',
    opacity: 0.6
  },

  // ローディングスピナー
  loadingSpinner: {
    width: '16px',
    height: '16px',
    border: '2px solid transparent',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },

  // リンク
  link: {
    color: COLORS.primary,
    textDecoration: 'none',
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '20px',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    background: 'none',
    border: 'none'
  },

  // リンク（ホバー時）
  linkHover: {
    color: COLORS.primaryDark,
    textDecoration: 'underline'
  },

  // 全般エラー
  generalError: {
    padding: '12px',
    backgroundColor: COLORS.dangerBg,
    borderRadius: '4px',
    border: `1px solid ${COLORS.dangerBorder}`,
    marginBottom: '20px'
  },

  // ローディング状態
  loadingContainer: {
    textAlign: 'center',
    padding: '40px',
    color: COLORS.textGray
  },

  // エラー状態
  errorContainer: {
    textAlign: 'center',
    padding: '40px'
  },

  // エラータイトル
  errorTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: COLORS.danger,
    marginBottom: '16px'
  }
};

// CSS アニメーション
export const newPasswordFormAnimations = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
    20%, 40%, 60%, 80% { transform: translateX(2px); }
  }
`;

// ユーティリティ関数
export const newPasswordFormUtils = {
  // 入力フィールドの状態に応じたスタイルを取得
  getInputStyle: (baseStyle, hasError, isFocused) => {
    let style = { ...baseStyle };

    if (hasError) {
      style = { ...style, ...newPasswordFormStyles.inputError };
    } else if (isFocused) {
      style = { ...style, ...newPasswordFormStyles.inputFocus };
    }

    return style;
  },

  // ボタンの状態に応じたスタイルを取得
  getButtonStyle: (baseStyle, isDisabled, isLoading) => {
    let style = { ...baseStyle };

    if (isDisabled || isLoading) {
      style = { ...style, ...newPasswordFormStyles.submitButtonDisabled };
    }

    return style;
  },

  // パスワード強度インジケーターのスタイルを取得
  getStrengthIndicatorStyle: (baseStyle, isValid) => {
    let style = { ...baseStyle };

    if (isValid) {
      style = { ...style, ...newPasswordFormStyles.strengthIndicatorValid };
    }

    return style;
  },

  // 総合評価のスタイルを取得
  getStrengthSummaryStyle: (baseStyle, isValid) => {
    let style = { ...baseStyle };

    if (isValid) {
      style = { ...style, ...newPasswordFormStyles.strengthSummarySuccess };
    } else {
      style = { ...style, ...newPasswordFormStyles.strengthSummaryDanger };
    }

    return style;
  }
};

// カラー定数もエクスポート（他のコンポーネントでも使用可能）
export { COLORS };

export default newPasswordFormStyles;